export enum ContractTypeEnum {
    CONTRACT = 'contract',
    SUBCONTRACT = 'subcontract',
    NONCADASTRALCONTRACT = 'nonCadastralContract',
    BARTER = 'barter',
    PURCHASE = 'purchase',
}